import {
  hmplusLimitedReleaseDetailConstants,
  createHMplusLimitedReleaseDetailConstants,
  editHMplusLimitedReleaseDetailConstants,
  addTargetHMplusLimitedReleaseDetailConstants,
  removeTargetHMplusLimitedReleaseDetailConstants,
  activateHMplusLimitedReleaseDetailConstants,
  deactivateHMplusLimitedReleaseDetailConstants,
  deleteHMplusLimitedReleaseDetailConstants,
} from "../_redux-constants";

export function hmplusLimitedReleasesDetailReducer(
  state = {
    hmplusLimitedReleaseDetailLoading: false,
    hmplusLimitedReleaseDetailData: null,
    hmplusLimitedReleaseDetailError: null,

    createHMplusLimitedReleaseDetailLoading: false,
    createHMplusLimitedReleaseDetailData: null,
    createHMplusLimitedReleaseDetailError: null,

    editHMplusLimitedReleaseDetailLoading: false,
    editHMplusLimitedReleaseDetailData: null,
    editHMplusLimitedReleaseDetailError: null,

    addTargetHMplusLimitedReleaseDetailLoading: false,
    addTargetHMplusLimitedReleaseDetailData: null,
    addTargetHMplusLimitedReleaseDetailError: null,

    removeTargetHMplusLimitedReleaseDetailLoading: false,
    removeTargetHMplusLimitedReleaseDetailData: null,
    removeTargetHMplusLimitedReleaseDetailError: null,

    activateHMplusLimitedReleaseDetailLoading: false,
    activateHMplusLimitedReleaseDetailData: null,
    activateHMplusLimitedReleaseDetailError: null,

    deactivateHMplusLimitedReleaseDetailLoading: false,
    deactivateHMplusLimitedReleaseDetailData: null,
    deactivateHMplusLimitedReleaseDetailError: null,

    deleteHMplusLimitedReleaseDetailLoading: false,
    deleteHMplusLimitedReleaseDetailData: null,
    deleteHMplusLimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        hmplusLimitedReleaseDetailLoading: true,
        hmplusLimitedReleaseDetailData: null,
        hmplusLimitedReleaseDetailError: null,
      });
    case hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        hmplusLimitedReleaseDetailLoading: false,
        hmplusLimitedReleaseDetailData: action.data,
      });
    case hmplusLimitedReleaseDetailConstants.HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        hmplusLimitedReleaseDetailLoading: false,
        hmplusLimitedReleaseDetailData: null,
        hmplusLimitedReleaseDetailError: action.error,
      });
    case createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createHMplusLimitedReleaseDetailLoading: true,
        createHMplusLimitedReleaseDetailData: null,
        createHMplusLimitedReleaseDetailError: null,
      });
    case createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createHMplusLimitedReleaseDetailLoading: false,
        createHMplusLimitedReleaseDetailData: action.data,
      });
    case createHMplusLimitedReleaseDetailConstants.CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createHMplusLimitedReleaseDetailLoading: false,
        createHMplusLimitedReleaseDetailData: null,
        createHMplusLimitedReleaseDetailError: action.error,
      });
    case editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editHMplusLimitedReleaseDetailLoading: true,
        editHMplusLimitedReleaseDetailData: null,
        editHMplusLimitedReleaseDetailError: null,
      });
    case editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editHMplusLimitedReleaseDetailLoading: false,
        editHMplusLimitedReleaseDetailData: action.data,
      });
    case editHMplusLimitedReleaseDetailConstants.EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editHMplusLimitedReleaseDetailLoading: false,
        editHMplusLimitedReleaseDetailData: null,
        editHMplusLimitedReleaseDetailError: action.error,
      });
    case addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        addTargetHMplusLimitedReleaseDetailLoading: true,
        addTargetHMplusLimitedReleaseDetailData: null,
        addTargetHMplusLimitedReleaseDetailError: null,
      });
    case addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        addTargetHMplusLimitedReleaseDetailLoading: false,
        addTargetHMplusLimitedReleaseDetailData: action.data,
      });
    case addTargetHMplusLimitedReleaseDetailConstants.ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        addTargetHMplusLimitedReleaseDetailLoading: false,
        addTargetHMplusLimitedReleaseDetailData: null,
        addTargetHMplusLimitedReleaseDetailError: action.error,
      });
    case removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        removeTargetHMplusLimitedReleaseDetailLoading: true,
        removeTargetHMplusLimitedReleaseDetailData: null,
        removeTargetHMplusLimitedReleaseDetailError: null,
      });
    case removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        removeTargetHMplusLimitedReleaseDetailLoading: false,
        removeTargetHMplusLimitedReleaseDetailData: action.data,
      });
    case removeTargetHMplusLimitedReleaseDetailConstants.REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        removeTargetHMplusLimitedReleaseDetailLoading: false,
        removeTargetHMplusLimitedReleaseDetailData: null,
        removeTargetHMplusLimitedReleaseDetailError: action.error,
      });
    case activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateHMplusLimitedReleaseDetailLoading: true,
        activateHMplusLimitedReleaseDetailData: null,
        activateHMplusLimitedReleaseDetailError: null,
      });
    case activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateHMplusLimitedReleaseDetailLoading: false,
        activateHMplusLimitedReleaseDetailData: action.data,
      });
    case activateHMplusLimitedReleaseDetailConstants.ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateHMplusLimitedReleaseDetailLoading: false,
        activateHMplusLimitedReleaseDetailData: null,
        activateHMplusLimitedReleaseDetailError: action.error,
      });
    case deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateHMplusLimitedReleaseDetailLoading: true,
        deactivateHMplusLimitedReleaseDetailData: null,
        deactivateHMplusLimitedReleaseDetailError: null,
      });
    case deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateHMplusLimitedReleaseDetailLoading: false,
        deactivateHMplusLimitedReleaseDetailData: action.data,
      });
    case deactivateHMplusLimitedReleaseDetailConstants.DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateHMplusLimitedReleaseDetailLoading: false,
        deactivateHMplusLimitedReleaseDetailData: null,
        deactivateHMplusLimitedReleaseDetailError: action.error,
      });
    case deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteHMplusLimitedReleaseDetailLoading: true,
        deleteHMplusLimitedReleaseDetailData: null,
        deleteHMplusLimitedReleaseDetailError: null,
      });
    case deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteHMplusLimitedReleaseDetailLoading: false,
        deleteHMplusLimitedReleaseDetailData: action.data,
      });
    case deleteHMplusLimitedReleaseDetailConstants.DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteHMplusLimitedReleaseDetailLoading: false,
        deleteHMplusLimitedReleaseDetailData: null,
        deleteHMplusLimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
